(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m1o2-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    Array.prototype.slice.call(document.querySelectorAll('[data-m1o2-faq]')).forEach(function (section) {
      var toggle = section.querySelector('[data-m1o2-faq-toggle-all]');
      var label = section.querySelector('[data-m1o2-faq-toggle-label]');
      var items = Array.prototype.slice.call(section.querySelectorAll('.m1o2-faq__item'));
      if (!toggle || !items.length) return;
      function sync() {
        var anyOpen = items.some(function (item) {
          return item.open;
        });
        toggle.setAttribute('aria-expanded', String(anyOpen));
        if (label) label.textContent = anyOpen ? 'Collapse All' : 'Expand All';
      }
      toggle.addEventListener('click', function () {
        var collapse = toggle.getAttribute('aria-expanded') !== 'false';
        items.forEach(function (item) {
          item.open = !collapse;
        });
        sync();
      });
      items.forEach(function (item) {
        item.addEventListener('toggle', sync);
      });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m1o2-footer"] && !Shopify.designMode) return;
  try {
    
  /* Shopify only injects its cookie-banner script (which defines window.privacyBanner)
     when the banner is due to show - once a visitor has chosen, or is outside the
     banner's regions, it is absent. So load it on demand, then open preferences;
     if that fails, follow the link's href. */
  (function () {
    var BANNER_SRC = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
    var loading = null;

    function loadBanner() {
      if (window.privacyBanner) return Promise.resolve(window.privacyBanner);
      if (!loading) {
        loading = new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          script.src = BANNER_SRC;
          script.async = true;
          script.onload = function () {
            window.privacyBanner ? resolve(window.privacyBanner) : reject(new Error('privacyBanner missing'));
          };
          script.onerror = reject;
          document.head.appendChild(script);
        }).catch(function (error) {
          loading = null;
          throw error;
        });
      }
      return loading;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-m1o2-cookie-prefs]');
      if (!link) return;
      event.preventDefault();
      loadBanner()
        .then(function (banner) {
          return banner.showPreferences();
        })
        .catch(function (error) {
          console.warn('Cookie preferences unavailable:', error);
          var href = link.getAttribute('href');
          if (href && href !== '#') window.location.href = href;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
